import theme from 'theme';

const customStyles = {
  table: {
    style: {
      tableLayout: 'fixed',
    },
  },
  headRow: {
    style: {
      backgroundColor: '#F4F5F7',
      border: `1px solid ${theme.palette.tables.border}`,
      borderBottom: `1px solid ${theme.palette.tables.borderRows}`,
      borderRadius: '5px 5px 0px 0px',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
      minHeight: 80,
    },
  },
  headCells: {
    style: {
      color: theme.palette.tables.color,
      fontSize: 14,
      fontWeight: 500,
      '&:hover div': {
        color: theme.palette.tables.color,
      },
      activeSortStyle: {
        color: theme.palette.tables.color,
        '&:hover:not(:focus)': {
          color: theme.palette.tables.color,
        },
      },
      inactiveSortStyle: {
        '&:hover': {
          color: theme.palette.tables.color,
        },
      },
    },
  },
  cells: {
    style: {
      color: theme.palette.tables.color,
      fontSize: 13,
      textAlign: 'left',
      padding: '0.5rem 1rem',
    },
  },
  rows: {
    style: {
      borderRight: `1px solid ${theme.palette.tables.border}`,
      borderLeft: `1px solid ${theme.palette.tables.border}`,
      borderBottom: `1px solid ${theme.palette.tables.borderRows}`,
      boxShadow: '0px 4px 4px rgb(0 0 0 / 5%)',
      minHeight: 56,
      '&:not(:last-of-type)': {
        borderBottomColor: theme.palette.tables.borderRows,
      },
    },
    highlightOnHoverStyle: {
      backgroundColor: theme.palette.tables.header,
      borderColor: `${theme.palette.tables.border} !important`,
      cursor: 'pointer',
      outlineStyle: 'inherit',
    },
  },
  pagination: {
    style: {
      border: 'none',
      borderBottom: `1px solid ${theme.palette.tables.border}`,
      borderLeft: `1px solid ${theme.palette.tables.border}`,
      borderRight: `1px solid ${theme.palette.tables.border}`,
      borderRadius: '0px 0px 5px 5px',
    },
  },
};

export default customStyles;
